import { render, staticRenderFns } from "./ViewReceiveTransferInventory.vue?vue&type=template&id=0b9516f1"
import script from "./ViewReceiveTransferInventory.vue?vue&type=script&lang=js"
export * from "./ViewReceiveTransferInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports